import { Outlet, useParams } from "react-router-dom";
import useCadEntregaLista from "../../Hooks/cadEntrega/lista";
import vinculoProduto from "../../Hooks/vinculoProduto/vinculoProduto";

const Entrega = () => {
    const { dtCompetencia, cdEntrega, pgOrigem } = useParams();
    const EntregaLista = useCadEntregaLista(dtCompetencia ?? "", cdEntrega, pgOrigem);
    const produtoVinculo = vinculoProduto()

    return (
        <Outlet context={EntregaLista} />
    )
}

export default Entrega;